import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRightIcon, BellPlusIcon, CheckIcon, ChevronRightIcon, HeartIcon, MapPinIcon, PawPrintIcon } from 'lucide-react';
import { PetCard } from '../components/animaux/PetCard';
import { LostFlow } from '../components/animaux/LostFlow';
import { PetRules } from '../components/animaux/PetAtna';
import { VetConnect } from '../components/animaux/VetConnect';
import { petReminders, petTodos, pets, sightings, sourceLabels } from '../data/animaux';
export function AnimalDetail() {
  const {
    id
  } = useParams();
  const pet = pets.find(item => item.id === id) ?? pets[0];
  const [lost, setLost] = useState(false);
  const [flowOpen, setFlowOpen] = useState(false);
  const [found, setFound] = useState(false);
  const todos = petTodos[pet.id] ?? [];
  const reminders = petReminders[pet.id] ?? [];
  return <main className="bg-white" data-id="element-1961" data-mp="1ezt7b0gxcozy">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-1962" data-mp="1eyrjrwiq2a1c">
        <nav aria-label="Fil d’Ariane" className="flex flex-wrap items-center gap-1.5 text-sm text-slate-500" data-id="element-1963" data-mp="2jm5tikwt2zyt">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1964" data-mp="2emkl7jvqxf9f">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1965" data-mp="2tkd1ie94a7oo" />
          <Link to="/mes-animaux" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-1966" data-mp="2oliet1813yza">
            Mes animaux
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1967" data-mp="20u3ch8g95ho1" />
          <span aria-current="page" data-id="element-1968" data-mp="1vyflqom4gggf">{pet.name}</span>
        </nav>

        <div className="mt-6 grid gap-10 lg:grid-cols-[minmax(0,520px)_minmax(0,1fr)] lg:gap-12" data-id="element-1969" data-mp="2amito3jq627v">
          <div data-id="element-1970" data-mp="25ur0rmd3jkek">
            <PetCard pet={pet} lost={lost} data-id="element-1971" data-mp="25v0vfn936fql" />

            {!lost ? <button type="button" onClick={() => setFlowOpen(true)} className="mt-3 inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-red-600 hover:text-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1972" data-mp="1i5g86s5wgwbi">
                <PawPrintIcon className="h-4 w-4" aria-hidden="true" data-id="element-1973" data-mp="2bmss3kb4q7xi" />
                Déclarer {pet.name} perdu
              </button> : <button type="button" onClick={() => {
            setLost(false);
            setFound(true);
          }} className="mt-3 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-1974" data-mp="2go9q9828bgae">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1975" data-mp="34bhxhvj7wzf2" />
                {pet.name} est retrouvé
              </button>}
          </div>

          <div data-id="element-1976" data-mp="xnqzqyy2h1n7">
            {found && <div className="mb-6 flex items-start gap-3 rounded-2xl bg-ville-indigo-soft px-5 py-4" data-id="element-1977" data-mp="xmpmcntkw32b">
                <HeartIcon className="mt-0.5 h-5 w-5 shrink-0 text-ville-indigo" aria-hidden="true" data-id="element-1978" data-mp="sqhdtt9vz844" />
                <div data-id="element-1979" data-mp="nvl7rp7tek80">
                  <p className="font-bold text-ville-navy" data-id="element-1980" data-mp="iyl6rspto7nr">{pet.name} est retrouvé</p>
                  <p className="text-sm text-slate-600" data-id="element-1981" data-mp="iwqqwster5qj">
                    L’alerte communautaire a été fermée. Merci aux citoyens qui ont aidé.
                  </p>
                </div>
              </div>}

            {lost && <section aria-labelledby="perdu-titre" className="mb-8 overflow-hidden rounded-3xl border border-slate-200" data-id="element-1982" data-mp="4zv47xk8hfs0">
                <div className="border-l-4 border-red-600 p-6" data-id="element-1983" data-mp="1jwbsdi1fcf">
                  <span className="inline-flex rounded-full bg-red-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-1984" data-mp="1zd36gaajgtno">
                    Perdu
                  </span>
                  <h2 id="perdu-titre" className="mt-3 text-xl font-extrabold text-ville-navy" data-id="element-1985" data-mp="22dwlghafbo2f">
                    {pet.name} est actuellement déclaré perdu.
                  </h2>
                  <p className="mt-1 text-sm text-slate-600" data-id="element-1986" data-mp="1sg9yr8mvus7w">
                    Avis communautaire envoyé · rayon de 1,5 km · aucune donnée personnelle partagée.
                  </p>

                  <div className="relative mt-5 h-40 overflow-hidden rounded-2xl bg-slate-100" data-id="element-1987" data-mp="1xh65dtymcsh0">
                    <div className="absolute inset-0 opacity-60 [background-image:linear-gradient(#cbd5e1_1px,transparent_1px),linear-gradient(90deg,#cbd5e1_1px,transparent_1px)] [background-size:28px_28px]" data-id="element-1988" data-mp="1jm3okbs8hipf" />
                    <div className="absolute left-1/2 top-1/2 h-28 w-28 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-ville-indigo bg-ville-indigo/10" data-id="element-1989" data-mp="1eov76dewtip8" />
                    <span className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-ville-indigo" data-id="element-1990" data-mp="10pvrhv9dke57" />
                  </div>
                  <p className="mt-2 text-xs text-slate-500" data-id="element-1991" data-mp="m1lrln64nnt1">
                    Dernier endroit connu et zone de recherche — il ne s’agit pas de la position actuelle de {pet.name}.
                  </p>

                  <h3 className="mt-6 text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-1992" data-mp="v44olqn8f67d">Signalements récents</h3>
                  <ol className="mt-3 space-y-3" data-id="element-1993" data-mp="q2ffigjkl2lx">
                    {sightings.map(sighting => <li key={sighting.time} className="flex gap-3 text-sm" data-id="element-1994" data-mp="14zetcm50lrou">
                        <span className="w-16 shrink-0 font-semibold text-slate-500" data-id="element-1995" data-mp="101d9hyzrlocb">{sighting.time}</span>
                        <span data-id="element-1996" data-mp="1dt1l8163qasr">
                          <span className="block font-bold text-ville-navy" data-id="element-1997" data-mp="1dve1m9w7od3p">{sighting.label}</span>
                          <span className="flex items-center gap-1 text-slate-500" data-id="element-1998" data-mp="19ubz9k6zzkxi">
                            <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1999" data-mp="1ns0nn209xa7b" />
                            {sighting.place}
                          </span>
                        </span>
                      </li>)}
                  </ol>
                </div>
              </section>}

            <section aria-labelledby="detail-a-faire" data-id="element-2000" data-mp="pfwmqmegaj7i">
              <h2 id="detail-a-faire" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-2001" data-mp="pf4rxdsogpia">
                À faire
              </h2>
              {todos.length === 0 ? <p className="mt-2 flex items-center gap-2 text-sm text-slate-500" data-id="element-2002" data-mp="z4obyms4mpeq">
                  <CheckIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-2003" data-mp="14418jz8svaui" />
                  Tout est à jour.
                </p> : <ul className="mt-4 space-y-3" data-id="element-2004" data-mp="184l5b1pgocg4">
                  {todos.map(todo => <li key={todo.id} className="rounded-2xl border border-slate-200 px-5 py-4" data-id="element-2005" data-mp="1d3eg2mdd5pcl">
                      <p className="text-[15px] font-bold text-ville-navy" data-id="element-2006" data-mp="39zvkdmw141jx">{todo.title}</p>
                      <p className="mt-0.5 text-sm text-slate-600" data-id="element-2007" data-mp="3ex3z1dhyxngf">{todo.detail}</p>
                      <button type="button" className="mt-3 inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-2008" data-mp="37exg5r2vhp6r">
                        {todo.cta}
                        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2009" data-mp="3q9ukd2ttr6en" />
                      </button>
                    </li>)}
                </ul>}
            </section>

            <section aria-labelledby="rappels-titre" className="mt-10" data-id="element-2010" data-mp="3ccpk5jgsl1rb">
              <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-2011" data-mp="3ceiga4ts43l2">
                <h2 id="rappels-titre" className="text-xl font-extrabold tracking-tight text-ville-navy" data-id="element-2012" data-mp="25070prz9nfta">
                  Rappels
                </h2>
                <button type="button" className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2013" data-mp="3w4sa32vubjc">
                  <BellPlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-2014" data-mp="nklw61otbgsg" />
                  Ajouter un rappel
                </button>
              </div>
              <ul className="mt-4 space-y-2" data-id="element-2015" data-mp="rkxkppkaq197">
                {reminders.map(reminder => <li key={reminder.id} className="flex flex-wrap items-baseline justify-between gap-2 rounded-2xl bg-slate-50 px-5 py-3" data-id="element-2016" data-mp="du13svzqf8hz">
                    <span data-id="element-2017" data-mp="irkh9tolvh8v">
                      <span className="block text-[15px] font-bold text-ville-navy" data-id="element-2018" data-mp="16iy81v73z4rq">{reminder.label}</span>
                      <span className="block text-xs text-slate-500" data-id="element-2019" data-mp="1bag8mi57z3c6">{sourceLabels[reminder.source]}</span>
                    </span>
                    <span className="text-sm text-slate-600" data-id="element-2020" data-mp="1kngo0taod78p">{reminder.date}</span>
                  </li>)}
              </ul>
              <p className="mt-3 text-xs text-slate-500" data-id="element-2021" data-mp="1uejru2uzo0bo">
                Les rappels et changements apparaissent dans{' '}
                <Link to="/notifications" className="font-bold text-ville-indigo hover:underline" data-id="element-2022" data-mp="1pfgm0g76pq2n">
                  Notifications
                </Link>
                . La facture de renouvellement est déposée dans{' '}
                <Link to="/mon-profil" className="font-bold text-ville-indigo hover:underline" data-id="element-2023" data-mp="xq52x2zm70c6">
                  Mon profil → Mes factures
                </Link>
                .
              </p>
            </section>
          </div>
        </div>

        <PetRules data-id="element-2024" data-mp="2n3ie9c659oms" />
        <VetConnect data-id="element-2025" data-mp="2n2pdcrtv9tck" />
      </div>

      <LostFlow pet={pet} open={flowOpen} onClose={() => setFlowOpen(false)} onConfirm={() => {
      setFlowOpen(false);
      setLost(true);
      setFound(false);
    }} data-id="element-2026" data-mp="2n1xhrh09rvma" />
    </main>;
}